import React, { Component } from 'react';
import { MuiThemeProvider, withStyles } from '@material-ui/core/styles';

import imgCanada from '../../assets/images/canada.png';
import { darkTheme } from '../../config/theme';
import TimeZoneClock from '../TimeZoneClock/TimeZoneClock';

class Header extends Component {

  render() {

    const { classes } = this.props;

    return (

      <MuiThemeProvider theme={ darkTheme }>

        <div className={ classes.container }>

          <div className={ ['overlay-gradient', classes.splashContainer].join(' ') } />

          <div className="header content">

            <div className="header-profile">
              <div className="header-photo">
                <img src="https://www.gravatar.com/avatar/d25d5ec23e48bc3b81f77eba3ca71aeb?s=200" alt="Cool Guy" />
              </div>

              <div className="header-text">
                <h1>Ian Lovett</h1>
                <h2>Front End / Full Stack Engineer</h2>
                <div className="timezone">
                    It is currently <span className={ classes.timeZoneClock }><TimeZoneClock /></span> in Kelowna, BC
                  <img src={ imgCanada } alt="Canada Flag" style={ { marginLeft: 8 } } />
                </div>
              </div>
            </div>

            {/* <div className="nav-buttons">
              <Button color="default" component={ Link } to='/portfolio'>Portfolio</Button>
              <Button color="default" href="/resume/pdf" target="resume">Resume</Button>
              <Button color="default" component={ Link } to='/chat'>Chat</Button>
            </div> */}

          </div>
        </div>

      </MuiThemeProvider>
    );
  }

}

const styles = {
  container: {
    minHeight: '240px',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column'
  },
  splashContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },
  timeZoneClock: {
    fontWeight: 'bold'
  }
};

export default withStyles(styles)(Header)



// WEBPACK FOOTER //
// ./src/components/Header/Header.js